<nav class="px-0 navbar navbar-expand-sm header"
  [ngClass]="_sharedDataService.currentSidebar === 'regular' ? 'sidebar-closed' : 'sidebar-open'">
  <div class="container-fluid g-0">
    <div class="navbar-text p-0 me-auto">
      @if (company) {
        <div class="company-name-and-label-container">
          <p class="company-name" appFsMask>{{company.name}}</p>
          @if (company.portfolio) {
            <span class="badge portfolio-label fs-block">{{company.portfolio.name}}</span>
          }
        </div>
      }
      @if (!company) {
        <div>
          <p class="company-name">{{title}}</p>
        </div>
      }
    </div>

    <ul class="navbar-nav">
      @if (showDocumentStatusButton) {
        <li class="nav-item px-2">
          <a
            class="nav-link"
            href="javascript:void(0);"
            #uploadStatusOrigin
            (click)="showUploadStatusPopover = !showUploadStatusPopover"
            >
            <div class="avatar">
              <i class="far fa-check-square"></i>
              @if (numDocuments > 0) {
                <span class="notification-badge"></span>
              }
            </div>
          </a>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="uploadStatusOrigin"
            [cdkConnectedOverlayOpen]="showUploadStatusPopover"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            [cdkConnectedOverlayPositions]="[{originX:'end',originY:'bottom',overlayX:'end',overlayY:'top'}]"
            (backdropClick)="showUploadStatusPopover = false">
            <app-upload-status-popover
              (closePopover)="showUploadStatusPopover = false"
              [isManualReviewer]="shouldDisplayManualReview()"
              [isSpreader]="shouldDisplaySpreading()"
              >
            </app-upload-status-popover>
          </ng-template>
        </li>
      }
      <li class="nav-item dropdown px-2">
        <a href="#" id="nbAcctDD" class="nav-link" data-bs-toggle="dropdown">
          <div class="avatar">
            <i class="far fa-question-circle"> </i>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-end">
          @if (showNumeratedSalesforceHelpLinks) {
            @if (userGuideService.userGuides.length > 0) {
              <span class="dropdown-item-text walkthrough-header"><strong>Articles</strong></span>
            }
            @for (userGuide of userGuideService.userGuides; track userGuide) {
              <a class="dropdown-item" target="_blank"
                href="{{userGuide.url}}">
                {{userGuide.name}}
              </a>
            }
            @if (userGuideService.userGuides.length > 0) {
              <div class="dropdown-divider" role="separator"></div>
            }
            <a class="dropdown-item user-guide" target="_blank" href="https://information.moodysanalytics.com/000000AJZUSRBLSUSR/introduction">
              <i class="fas fa-clipboard-user"></i>User Guide
            </a>
          }
          @if (showStorylaneTrainingButton) {
            <a class="dropdown-item how-to-use-numerated" target="_blank" href="https://numerated.storylane.io/share/mbgtcrj0yghv">
              <i class="fas fa-book"></i>How to Use Automated Spreading
            </a>
          }
          @if (customerSupportUrl || contactSupportEmail) {
            <div class="dropdown-divider" role="separator"></div>
            <a class="dropdown-item contact-support-option" (click)="openContactSupportEmailModal()">
              <i class="fas fa-question-circle"></i>Contact Support
            </a>
          }
        </div>
      </li>
      <li class="nav-item dropdown px-2">

        <a href="#" id="nbAcctDD" class="nav-link" data-bs-toggle="dropdown">
          <div class="avatar">
            @if (!userService.user || !userService.user.img) {
              <i class="fas fa-user-circle"></i>
            }
            @if (userService.user && userService.user.img) {
              <img
                [src]="sanitizer.bypassSecurityTrustResourceUrl(userService.user.img)">
            }
          </div>
          {{user_name()}}
          <div class="arrow-down">
            <i class="fas fa-chevron-down"></i>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-end">
          <a class="dropdown-item" [routerLink]="['/logout']">Log Out</a>
          @if (userHasMultipleTenants) {
            <a class="dropdown-item version">Frontend: <span class="current-version-number">{{frontendVersion}}</span></a>
            <a class="dropdown-item version">Backend: <span class="backend-version-number">{{backendVersion}}</span></a>
          }
          @if (bankId) {
            <a class="dropdown-item bankId">Tenant Id: {{bankId}}</a>
          }
          @if (userHasMultipleTenants) {
            <div class="dropdown-divider" role="separator"></div>
          }
          @if (userHasMultipleTenants) {
            <a class="dropdown-item switch-tenant" (click)="switchTenant()">
              <i class="fas fa-university"></i> Switch Tenant
            </a>
          }
        </div>
      </li>
    </ul>
  </div>
</nav>
